<template>
  <div class="card home-card">
    <div class="card-image">
      <span class="icon fa-7x" :class="icon"></span>
    </div>
    <div class="card-content">
      <h3>{{ title }}</h3>
      <p>{{ text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "HomeCard",
  props: {
    title: String,
    text: String,
    icon: String,
  },
};
</script>
